import { createAction, props } from '@ngrx/store';
import { Tiles } from '../containers/tile-wrapper/tile-component-accessor';
import { TileDataUnion } from '../models/tile-data.model';
import { TileParametersBase } from '../models/tile-parameters.model';
import { TileLoadProps, TileStateKey } from './tile.reducer';

export const tileLoad = createAction('[Tile] Tile rendered', props<TileLoadProps>());
export const tileLoadedSuccess = createAction(
   '[API] Tile loaded success',
   props<{ tileData: TileDataUnion; dashboardTileId: TileStateKey }>()
);
export const tileLoadedFailure = createAction(
   '[API] Tile loaded failure',
   props<{ error: any; dashboardTileId: TileStateKey }>()
);

export const clearTileBatchQueue = createAction('[Tile] Clear Tile Batch Queue');

export const tileSave = createAction(
   '[Tile] Tile Save',
   props<{ parameters: TileParametersBase; dashboardTileId: number; tileId: Tiles }>()
);

export const deleteDashboardTile = createAction('[Tile] Delete Tile', props<{ dashboardTileId: number }>());

export const deleteDashboardTileSuccess = createAction(
   '[API] Delete Tile Success',
   props<{ dashboardTileId: number }>()
);

export const deleteDashboardTileFailure = createAction('[API] Delete Tile Failiure', props<{ error: any }>());

export const tileSaveSuccess = createAction(
   '[API] Tile Save Success',
   props<{
      dashboardTileLayoutConfigurations: {
         dashboardTileId: number;
         name: string | null;
         color: string | null;
         refreshTimeSeconds: number | null;
         fields: string[];
      };
   }>()
);

export const tileSaveFailure = createAction(
   '[API] Tile Save Failiure',
   props<{ error: any; dashboardTileId: number }>()
);
